import React from 'react';
import {observer} from 'mobx-react';
import './ts-mute-button.style.scss';
import {requireImage} from '../../../utils/utils';

interface TsMuteButtonProps {
    useNewInterface: boolean;
    isMicrophoneMuted: boolean;
    isSupportAudio: boolean;
    toggleMute: (event: React.MouseEvent) => void;
}

const TsMuteButton: React.FC<TsMuteButtonProps> = observer(
    ({useNewInterface, isMicrophoneMuted, isSupportAudio, toggleMute}) => {
        if (!isSupportAudio) {
            return <React.Fragment />;
        }

        const handleClick = (e: React.MouseEvent) => {
            e.preventDefault();
            toggleMute(e);
        };

        return (
            <div className={useNewInterface ? 'ts-mute-toggle' : ''}>
                {!isMicrophoneMuted ? (
                    <a
                        href='#'
                        onClick={handleClick}
                        className={`dashboard-main-video-tool off ${!useNewInterface ? ' dashboard-mute text-center' : ''}`}>
                        <div className={useNewInterface ? 'toggle-mute-icon' : ''}>
                            <img
                                src={
                                    useNewInterface
                                        ? requireImage('audio-on.png')
                                        : requireImage('icon-mute-golden.png')
                                }
                                alt='Mute'
                            />
                        </div>
                    </a>
                ) : (
                    <a
                        href='#'
                        onClick={handleClick}
                        className={`dashboard-main-video-tool ${!useNewInterface ? ' dashboard-mute text-center' : ''}`}>
                        <div className={useNewInterface ? 'toggle-mute-icon off' : ''}>
                            <img
                                src={
                                    useNewInterface
                                        ? requireImage('audio-off.png')
                                        : requireImage('icon-unmute-golden.png')
                                }
                                alt='Unmute'
                            />
                        </div>
                    </a>
                )}
            </div>
        );
    }
);

export default TsMuteButton;
